var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationInUse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "location_in_use") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 18,
    cy: 18,
    r: 11
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-40.9%",
    y: "-31.8%",
    width: "181.8%",
    height: "181.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "path-3",
    cx: 12,
    cy: 12,
    r: 11
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0 5.7661924 5.45384419 0 4.26056527 4.95915677 7 6.60691777 1.04354525 12.8333333 2.96722558 7.54805675"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location_in_use",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Slices"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rounded-Element"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#207ED8",
    fillRule: "evenodd",
    cx: 18,
    cy: 18,
    r: 12
  })), /*#__PURE__*/React.createElement("g", {
    id: "Third-Party-Icon-new",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fillOpacity: 0,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons/ic_energy_bolt_solid",
    mask: "url(#mask-4)",
    fillRule: "evenodd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 5.000000)",
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.500000, 0.583333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "ic_energy_middle-copy-17",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Fills/Virta-UI/Glyph",
    mask: "url(#mask-6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.500000, -0.583333)"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationInUse);
export default __webpack_public_path__ + "static/media/location_in_use.1149314df26bbf9898e7791ec6cf65f3.svg";
export { ForwardRef as ReactComponent };